import { memo, useMemo } from 'react';

import { Heading, Text } from '@/components/core';
import { ValidationFilledLogo } from '@/components/logos';
import { MultiProfileBadge } from '@/components/ui';
import { useListUsers } from '@/hooks/api';

export const IValidationNode = () => {
  const { data: users } = useListUsers();
  const profileIds = useMemo(() => users?.data.map((u) => u.profileId), [users]);

  return (
    <div className="max-w-[24rem] min-w-[15rem]">
      <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
        <ValidationFilledLogo variant="primary" size="lg" />
        <Heading size="lg">Manual review</Heading>
      </div>
      <div className="gap-2 pt-2">
        <Text className="flex flex-row flex-wrap items-center gap-2 font-medium text-gray-600">
          Assign to:
          <MultiProfileBadge profileIds={profileIds} />
        </Text>
      </div>
    </div>
  );
};

export const ValidationNode = memo(IValidationNode);
